/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/reasonCodeOperationModal/reasonCodeOperationStrategies" />
import { IReasonCode, RejectOperation } from "../rejectionManagementWizard/interfaces";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";
import { postPutOnHoldCodesDto } from "../putOnHoldModal/services";
import { ReasonCodeOperationType } from "../shared/interfaces";
import { translateKeyBase } from "./reasonCodeOperationModal";

export interface ReasonCodeOperationStrategy {
    title: string;
    submitLabel: string;
    searchLabel?: string;
    rejectOperation?: RejectOperation;
    onReasonsConfirm?: (selectedReason: IReasonCode[]) => void;

    submit: (args: {
        documentId: number;
        selection: IReasonCode[];
        taskId: number;
        entityType: string;
        documentType: string;
        onReasonsConfirm?: (selectedReason: IReasonCode[]) => void;
    }) => Promise<void>;
}

export const reasonCodeStrategies: Partial<Record<ReasonCodeOperationType, ReasonCodeOperationStrategy>> = {
    [ReasonCodeOperationType.PutOnHold]: {
        title: translate(`${translateKeyBase}/onHoldInvoice`),
        submitLabel: translate("#Core/putOnHold"),
        searchLabel: translate(`${translateKeyBase}/selectReasonForOnHold`),
        rejectOperation: null,

        submit: async ({ documentId, selection, taskId, entityType, documentType }) => {
            await postPutOnHoldCodesDto({
                documentId,
                invoiceRejectionReasonItems: selection.map(rc => ({
                    reasonCodeId: rc.id,
                    actionId: rc.rejectionActionId
                })),
                operation: ReasonCodeOperationType[ReasonCodeOperationType.PutOnHold],
                taskId: taskId,
                documentType,
                putOnHoldEntityType: entityType
            });
        }
    },
    [ReasonCodeOperationType.RejectDeviation]: {
        title: translate("#PurchaseToPay/documentReasonCodes/rejectManagementWizard/selectReasonCode"),
        submitLabel: translate("#Enterprise/reject"),
        rejectOperation: RejectOperation.Deviation,

        submit: async ({ selection, onReasonsConfirm }) => {
            if (onReasonsConfirm) {
                onReasonsConfirm(selection);
            }
        }
    }
};
